import forge from 'node-forge'
import moment from 'moment'

const formatKey = function(key){
  if (!key.startsWith('-----BEGIN PUBLIC KEY-----')) {
    key = '-----BEGIN PUBLIC KEY-----\n' + key
  }
  if (!key.endsWith('-----END PUBLIC KEY-----')) {
    key = key + '\n-----END PUBLIC KEY-----'
  }
  return key
}

/**
 * 按 UTF-8 最大字节长度切分字符串
 * @param {string} str 原始字符串
 * @param {number} maxByteLength 每段最大字节长度
 * @returns {string[]}
 */
function splitByUtf8ByteLength(str, maxByteLength) {
  if (!str || maxByteLength <= 0) return []

  const result = []
  let current = ''
  let currentBytes = 0

  for (const ch of str) {
    // 计算当前字符的 UTF-8 字节数
    const byteLength = new TextEncoder().encode(ch).length

    if (currentBytes + byteLength > maxByteLength) {
      result.push(current)
      current = ch
      currentBytes = byteLength
    } else {
      current += ch
      currentBytes += byteLength
    }
  }

  if (current) {
    result.push(current)
  }

  return result
}

export default {
  
  create () {
    let uid = sessionStorage.getItem('user_uid')
    let key = formatKey(sessionStorage.getItem('key'))
    let publicKey = forge.pki.publicKeyFromPem(key)
    const timestamp = moment().unix()
    let str = sessionStorage.getItem('ss_id')
    str = str.concat('|')
    str = str.concat(uid)
    str = str.concat('|')
    str = str.concat(timestamp)
    let encrypted = publicKey.encrypt(str)
    return forge.util.encode64(encrypted)
  },
  encryption(data){
    let result = []
    if(data === null || typeof data === 'undefined'){
      return result
    }
    let key = formatKey(sessionStorage.getItem('key'))
    try{
      let publicKey = forge.pki.publicKeyFromPem(key)
      let json = JSON.stringify(data)
      let jsons = splitByUtf8ByteLength(json,200)
      for(let one of jsons){
        const utf8Bytes = forge.util.encodeUtf8(one)
        let encrypted = publicKey.encrypt(utf8Bytes, 'RSAES-PKCS1-V1_5')
        result.push(forge.util.encode64(encrypted))
      }
    }catch(err){
    }
    return result
  },
  decode64(data){
    // 将 Base64 字符串转换为字节数组
    const decodedBytes = forge.util.decode64(data)
    // 将字节数组转换为字符串
    return forge.util.decodeUtf8(decodedBytes)
  }
  
}
